import { render, staticRenderFns } from "./CategoryGroupConfig.vue?vue&type=template&id=5e66c330"
import script from "./CategoryGroupConfig.js?vue&type=script&lang=js&external"
export * from "./CategoryGroupConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports